import { Component, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MessageService } from '@progress/kendo-angular-l10n';
import { DrawerComponent, DrawerItemExpandedFn, DrawerMode, DrawerSelectEvent } from '@progress/kendo-angular-layout';
import { User } from 'src/app/global-functions';
import { CustomMessagesService } from '../../services/custom-messages.service';
import { Solutions } from 'src/app/utils/solutions';
import { Profiles } from 'src/app/utils/profiles';

@Component({
    selector: 'maters-root',
    templateUrl: './master.component.html'
})
export class MasterComponent implements OnDestroy {
    public selected = 'Team';
    public items: Array<any> = [];
    public customMsgService: CustomMessagesService;
    public mode: DrawerMode = 'push';
    public mini = true;
    public expanded = true;

    constructor(private router: Router, public msgService: MessageService) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.draw();
    }

    draw() {
        // Update Drawer selected state when change router path
        this.router.events.subscribe((route: any) => {
            if (route instanceof NavigationStart) {
                this.items = this.drawerItems().map((item) => {
                    if (item.path && item.path === route.url) {
                        item.selected = true;
                        return item;
                    } else {
                        item.selected = false;
                        return item;
                    }
                });
            }
        });

        this.setDrawerConfig();

        this.customMsgService.localeChange.subscribe(() => {

            this.items = this.drawerItems();
        });

        window.addEventListener('resize', () => {

            this.setDrawerConfig();
        });
    }

    ngOnDestroy() {
        window.removeEventListener('resize', () => { });
    }

    public setDrawerConfig() {
        const pageWidth = window.innerWidth;
        if (pageWidth <= 770) {
            this.mode = 'overlay';
            this.mini = false;
        } else {
            this.mode = 'push';
            this.mini = true;
        }
    }

    public drawerItems() {

        //Get user in session
        var user = User.userInSession();

        //Get user profile
        var idFuncao = user.IDFuncao;

        //Get user solution
        var idSolucao = user.IDSolucaoEntidade;

        //Alterar cor principal
        var corPrincipal = user.CorPrincipalEntidade;
        document.documentElement.style.setProperty('--theme-color-principal', corPrincipal);

        //Alterar cor secundaria
        var carSecundaria = user.CorSecundariaEntidade;
        document.documentElement.style.setProperty('--theme-color-secondary', carSecundaria);

        //* Permições de acesso por perfil de utilizador

        //Dashboard Industrial Vending
        var accessDashboardIndustrialVendingProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Dashboard Tool Management
        var accessDashboardToolManagementProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Dashboard Industrial Vending and Tool Management
        var accessDashboardIndustrialVendingToolManagementProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        /* //Alterar Password
        var accessAlterarPasswordProfiles = [
            //Profiles.Administrador,
            //Profiles.Supervisor,
            //Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Parametros
        var accessParametrosProfiles = [
            //Profiles.Administrador,
            //Profiles.Supervisor,
            //Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Entidades
        var accessEntidadesProfiles = [
            //Profiles.Administrador,
            //Profiles.Supervisor,
            //Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ]; */

        //Locais
        var accessLocaisProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Armarios
        var accessArmariosProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Teams
        var accessTeamsProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Users
        var accessUsersProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Tooltypes
        var accessTooltypesProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Toolsubtypes
        var accessToolsubtypesProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //lista de Ferramentas
        var accessListaDeFerramentasProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Centros de Custo
        var accessCentrosDeCustoProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Artigos
        var accessArtigosProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Anomalias
        var accessAnomaliasProfiles = [
            Profiles.Administrador,
            //Profiles.Supervisor,
            //Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Inventario
        var accessInventarioProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Consumo
        var accessConsumoProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Movimentos Tool Manegament
        var accessMovimentosToolManegamentProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Movimentos Industrial Vending
        var accessMovimentosIndustrialVendingProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //Alertas
        var accessAlertasProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Diretor,
            //Profiles.RespFerramentas,
            //Profiles.Manutencao,
            //Profiles.Repositor,
            //Profiles.Limpeza,
            //Profiles.Colaborador
        ];

        //* Permições de acesso por soluções

        //Dashboard Industrial Vending 
        var accessDashboardIndustrialVendingSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            //Solutions.IndustrialVendingToolManagement,
        ];

        //Dashboard Tool Management
        var accessDashboardToolManagementSolutions = [
            //Solutions.IndustrialVending,
            Solutions.ToolManegament,
            //Solutions.IndustrialVendingToolManagement,
        ];

        //Dashboard Industrial Vending and Tool Management
        var accessDashboardIndustrialVendingToolManagementSolutions = [
            //Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

/*         //Alterar Password
        var accessAlterarPasswordSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Parametros
        var accessParametrosSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Entidades
        var accessEntidadesSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ]; */

        //Locais
        var accessLocaisSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Armarios
        var accessArmariosSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Teams
        var accessTeamsSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Users
        var accessUsersSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Tooltypes
        var accessTooltypesSolutions = [
            //Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Toolsubtypes
        var accessToolsubtypesSolutions = [
            //Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Lista de Ferramentas
        var accessListaDeFerramentasSolutions = [
            //Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Centros de Custo
        var accessCentrosDeCustoSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Artigos
        var accessArtigosSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Anomalias
        var accessAnomaliasSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Inventario
        var accessInventarioSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Consumo
        var accessConsumoSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Movimentos Tool Manegament
        var accessMovimentosToolManegamentSolutions = [
            //Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Movimentos Industrial Vending
        var accessMovimentosIndustrialVendingSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        //Alertas
        var accessAlertasSolutions = [
            Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.IndustrialVendingToolManagement,
        ];

        var menus = new Array<any>();

        if (idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: "Tool Managament", icon: 'k-i-chart-line-markers', path: '/dashboardtm', selected: true });
            menus.push({ text: "Industrial Vending", icon: 'k-i-chart-line-markers', path: '/dashboardiv', selected: true });
            menus.push({ text: "Industrial & Tool ", icon: 'k-i-chart-line-markers', path: '/dashboardivtm', selected: true });
            menus.push({ separator: true });
        }
        else {
            //Dashboard
            if (accessDashboardToolManagementProfiles.indexOf(idFuncao) >= 0 && accessDashboardToolManagementSolutions.indexOf(idSolucao) >= 0) {
                menus.push({ text: this.customMsgService.translate('dashboard'), icon: 'k-i-chart-line-markers', path: '/dashboardtm', selected: true });
            }
            if (accessDashboardIndustrialVendingProfiles.indexOf(idFuncao) >= 0 && accessDashboardIndustrialVendingSolutions.indexOf(idSolucao) >= 0) {
                menus.push({ text: this.customMsgService.translate('dashboard'), icon: 'k-i-chart-line-markers', path: '/dashboardiv', selected: true });
            }
            if (accessDashboardIndustrialVendingToolManagementProfiles.indexOf(idFuncao) >= 0 && accessDashboardIndustrialVendingToolManagementSolutions.indexOf(idSolucao) >= 0) {
                menus.push({ text: this.customMsgService.translate('dashboard'), icon: 'k-i-chart-line-markers', path: '/dashboardtmiv', selected: true });
            }
            menus.push({ separator: true });
        }

        //Gestão de armários
        if (accessArmariosSolutions.indexOf(idSolucao) >= 0 || accessLocaisSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (accessArmariosProfiles.indexOf(idFuncao) >= 0 || accessLocaisProfiles.indexOf(idFuncao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('gestaoArmarios'), selected: false, disabled: true });
            }
            if (accessLocaisProfiles.indexOf(idFuncao) >= 0 && accessLocaisSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('locais'), icon: 'k-i-marker-pin', path: '/sites', selected: false });
            }
            if (accessArmariosProfiles.indexOf(idFuncao) >= 0 && accessArmariosSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('armarios'), icon: 'k-i-set-column-position', path: '/lockers', selected: false });
            }
            menus.push({ separator: true });
        }

        //Gestão de utilizadores
        if (accessTeamsSolutions.indexOf(idSolucao) >= 0 || accessUsersSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (accessTeamsProfiles.indexOf(idFuncao) >= 0 || accessUsersProfiles.indexOf(idFuncao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('gestaoUtilizadores'), selected: false, disabled: true });
            }
            if (accessTeamsProfiles.indexOf(idFuncao) >= 0 && accessTeamsSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('teams'), icon: 'k-i-myspace', path: '/teams', selected: false });
            }
            if (accessUsersProfiles.indexOf(idFuncao) >= 0 && accessUsersSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('users'), icon: 'k-i-user', path: '/users', selected: false });
            }
            menus.push({ separator: true });
        }

        //Gestão de ferramentas
        if (accessTooltypesSolutions.indexOf(idSolucao) >= 0 || accessToolsubtypesSolutions.indexOf(idSolucao) >= 0 || accessListaDeFerramentasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (accessTooltypesProfiles.indexOf(idFuncao) >= 0 || accessToolsubtypesProfiles.indexOf(idFuncao) >= 0 || accessListaDeFerramentasProfiles.indexOf(idFuncao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('gestaoFerramentas'), selected: false, disabled: true });
            }
            if (accessTooltypesProfiles.indexOf(idFuncao) >= 0 && accessTooltypesSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('tooltypes'), icon: 'k-i-folder', path: '/toolstypes', selected: false });
            }
            if (accessToolsubtypesProfiles.indexOf(idFuncao) >= 0 && accessToolsubtypesSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('toolsubtypes'), icon: 'k-i-folder-open', path: '/toolssubtypes', selected: false });
            }
            if (accessListaDeFerramentasProfiles.indexOf(idFuncao) >= 0 && accessListaDeFerramentasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('listaDeFerramentas'), icon: 'k-i-wrench', path: '/tools', selected: false });
            }
            menus.push({ separator: true });
        }

        //Gestão de artigos
        if (accessCentrosDeCustoSolutions.indexOf(idSolucao) >= 0 || accessArtigosSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (accessCentrosDeCustoProfiles.indexOf(idFuncao) >= 0 || accessArtigosProfiles.indexOf(idFuncao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('gestaoArtigos'), selected: false, disabled: true });
            }

            if (accessCentrosDeCustoProfiles.indexOf(idFuncao) >= 0 && accessCentrosDeCustoSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('centrosDeCusto'), icon: 'k-i-dollar', path: '/costcenters', selected: false });
            }
            if (accessArtigosProfiles.indexOf(idFuncao) >= 0 && accessArtigosSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('artigos'), icon: 'k-i-cart', path: '/items', selected: false });
            }
            menus.push({ separator: true });
        }

        //Relatórios
        if (accessInventarioSolutions.indexOf(idSolucao) >= 0 || accessConsumoSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (accessInventarioProfiles.indexOf(idFuncao) >= 0 || accessConsumoProfiles.indexOf(idFuncao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('relatorios'), selected: false, disabled: true });
            }
            if (accessInventarioProfiles.indexOf(idFuncao) >= 0 && accessInventarioSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('inventario'), icon: 'k-i-track-changes-enable', path: '/inventory', selected: false });
            }
            if (accessConsumoProfiles.indexOf(idFuncao) >= 0 && accessConsumoSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('consumo'), icon: 'k-i-file', path: '/consumption', selected: false });
            }
            menus.push({ separator: true });
        }

        //Eventos
        if (accessMovimentosToolManegamentSolutions.indexOf(idSolucao) >= 0 || accessMovimentosIndustrialVendingSolutions.indexOf(idSolucao) >= 0 || accessAlertasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (accessMovimentosToolManegamentProfiles.indexOf(idFuncao) >= 0 || accessMovimentosIndustrialVendingProfiles.indexOf(idFuncao) >= 0 || accessAlertasProfiles.indexOf(idFuncao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('eventos'), selected: false, disabled: true });
            }
            if (accessMovimentosToolManegamentProfiles.indexOf(idFuncao) >= 0 && accessMovimentosToolManegamentSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('movimentos'), icon: 'k-i-reload', path: '/movementstm', selected: false });
            }
            if (accessMovimentosIndustrialVendingProfiles.indexOf(idFuncao) >= 0 && accessMovimentosIndustrialVendingSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('movimentos'), icon: 'k-i-arrow-rotate-ccw', path: '/movementsiv', selected: false });
            }
            if (accessAlertasProfiles.indexOf(idFuncao) >= 0 && accessAlertasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('alertas'), icon: 'k-i-exclamation-circle', path: '/alerts', selected: false });
            }
            menus.push({ separator: true });
        }

        //Configurações
        if (/* accessAlterarPasswordSolutions.indexOf(idSolucao)>=0 ||*/ /* accessParametrosSolutions.indexOf(idSolucao) >= 0 || accessEntidadesSolutions.indexOf(idSolucao)>=0 || */ accessAnomaliasProfiles.indexOf(idFuncao) >= 0 && accessAnomaliasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            if (/* accessAlterarPasswordProfiles.indexOf(idFuncao)>=0  ||*/ /* accessParametrosProfiles.indexOf(idFuncao) >= 0 /* || accessEntidadesProfiles.indexOf(idFuncao)>=0 || */accessAnomaliasProfiles.indexOf(idFuncao) >= 0 && accessAnomaliasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('configuracoes'), selected: false, disabled: true });
            }
            if (/* accessEntidadesProfiles.indexOf(idFuncao)>=0 && accessEntidadesSolutions.indexOf(idSolucao)>=0 || */ idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('entidades'), icon: 'k-i-list-unordered-outline', path: '/entities', selected: false });
            }
            if (/* accessParametrosProfiles.indexOf(idFuncao) >= 0 &&  accessParametrosSolutions.indexOf(idSolucao) >= 0 || */ idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('parametros'), icon: 'k-i-cog', path: '/parameters', selected: false });
            }

            if (accessAnomaliasProfiles.indexOf(idFuncao) >= 0 && accessAnomaliasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
                menus.push({ text: this.customMsgService.translate('anomalias'), icon: 'k-i-bell', path: '/anomaly', selected: false });
            }
        }

        return menus;
    }

    public toggleDrawer(drawer: DrawerComponent): void {
        drawer.toggle();
    }

    public isItemExpanded: DrawerItemExpandedFn = (item): boolean => {
        return true;
    };

    public onSelect(ev: DrawerSelectEvent, drawer: DrawerComponent): void {
        drawer.autoCollapse = false;
        this.router.navigate([ev.item.path]);
        this.selected = ev.item.text;
        this.expanded = true;
    }
}
